module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M20 12v2c0 4.418-3.58 8-8 8s-8-3.582-8-8v-2c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2v2c0 5.946 4 10.868 10 11.82V28H6.02c-1.106 0-2 .894-2 2s.894 2 2 2h12c1.106 0 2-.894 2-2s-.894-2-2-2H14v-2.18c6-.954 10-5.876 10-11.82v-2c0-1.106-.894-2-2-2-1.106 0-2 .894-2 2zm-8 6c-2.208 0-4-1.792-4-4V4c0-2.208 1.792-4 4-4s4 1.792 4 4v10c0 2.208-1.792 4-4 4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/microphone-1.js
// module id = 1276
// module chunks = 14